import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {createDivIn, createImgIn, createParagraphIn} from '../../ui_utils/DomUtils'

export interface BadgeData {
    text: TranslationObject
    icon: LobbyImage
    background?: {
        backgroundColorClass: 'mm-badge-green' | 'mm-badge-yellow'
        fillPercentage: number
    }
}

export class UIProgressBadgeElement {
    private readonly container: HTMLDivElement
    private currentData: BadgeData | undefined

    constructor(parent: HTMLElement, initialData?: BadgeData) {
        this.container = createDivIn(parent, 'mm-mode-card-progress')
        if(initialData != undefined) this.update(initialData)
    }

    update(data: BadgeData) {
        this.currentData = data
        this.render()
    }

    private render() {
        if(this.currentData == undefined) return

        this.container.replaceChildren()
        this.container.className = 'mm-mode-card-progress'

        if(this.currentData.background != undefined) {
            this.container.classList.add(this.currentData.background.backgroundColorClass)
            const progressFill = createDivIn(this.container, 'mm-mode-card-progress-fill')
            progressFill.style.width = `${this.currentData.background.fillPercentage}%`
        }

        createImgIn(this.container, this.currentData.icon)
        createParagraphIn(this.container, this.currentData.text, '')
    }
}

